// extracted by mini-css-extract-plugin
module.exports = {"title":"Content_title__MStWx","paragraph":"Content_paragraph___0Yjl","list":"Content_list__B_3_e","listItem":"Content_listItem__Zrasp"};